var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_244_2124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.34961,
    y: 4.4375,
    width: 16.0295,
    height: 15.75,
    rx: 7.87499,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_244_2124)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6199 11.8341C10.4792 11.6022 10.3984 11.3315 10.3984 11.0424C10.3984 10.183 11.1124 9.48633 11.993 9.48633C12.5758 9.48633 13.0855 9.79138 13.3637 10.2468C13.6419 9.79138 14.1517 9.48634 14.7344 9.48634C15.6151 9.48634 16.329 10.183 16.329 11.0424C16.329 11.3315 16.2482 11.6022 16.1075 11.8341H16.1334L13.6156 15.1374L10.9352 12.2068C10.8421 12.1262 10.7588 12.0352 10.6871 11.9356L10.5943 11.8341H10.6199Z",
    fill: "url(#paint0_radial_244_2124)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.4272 14.4566C12.6812 13.6826 11.4163 11.9626 11.1892 11.6031C10.8534 11.0716 11.2451 9.95256 12.3082 10.2043C11.7114 10.4375 11.0997 11.6143 13.4272 14.4566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4272 14.4566C12.6812 13.6826 11.4163 11.9626 11.1892 11.6031C10.8534 11.0716 11.2451 9.95256 12.3082 10.2043C11.7114 10.4375 11.0997 11.6143 13.4272 14.4566Z",
    stroke: "white",
    strokeWidth: 0.0559512
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_244_2124",
    x: 0.573777,
    y: 0.855626,
    width: 25.581,
    height: 25.3017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.19396
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.38792
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_244_2124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_244_2124",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_244_2124",
    x: 9.50322,
    y: 8.59111,
    width: 8.16774,
    height: 7.88844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.223805,
    dy: 0.223805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.559512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_244_2124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_244_2124",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.223805,
    dy: -0.279756
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.279756
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_244_2124"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_244_2124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8218 10.8991) rotate(54.0204) scale(5.0978 5.17999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9610E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIcon);
export default __webpack_public_path__ + "static/media/LoveIcon.cae81e65301687d4e2e383a9f28ede75.svg";
export { ForwardRef as ReactComponent };